export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';

// KPI Summary
export const DATA_ANALYTICS_KPI_START = 'DATA_ANALYTICS_KPI_START';
export const DATA_ANALYTICS_KPI_SUCCESS = 'DATA_ANALYTICS_KPI_SUCCESS';
export const DATA_ANALYTICS_KPI_FAIL = 'DATA_ANALYTICS_KPI_FAIL';

// Trend Charts
export const DATA_ANALYTICS_TRENDS_START = 'DATA_ANALYTICS_TRENDS_START';
export const DATA_ANALYTICS_TRENDS_SUCCESS = 'DATA_ANALYTICS_TRENDS_SUCCESS';
export const DATA_ANALYTICS_TRENDS_FAIL = 'DATA_ANALYTICS_TRENDS_FAIL';

// Exception Panels
export const DATA_ANALYTICS_EXCEPTIONS_START = 'DATA_ANALYTICS_EXCEPTIONS_START';
export const DATA_ANALYTICS_EXCEPTIONS_SUCCESS = 'DATA_ANALYTICS_EXCEPTIONS_SUCCESS';
export const DATA_ANALYTICS_EXCEPTIONS_FAIL = 'DATA_ANALYTICS_EXCEPTIONS_FAIL';

// Portfolio Health
export const DATA_ANALYTICS_PORTFOLIO_START = 'DATA_ANALYTICS_PORTFOLIO_START';
export const DATA_ANALYTICS_PORTFOLIO_SUCCESS = 'DATA_ANALYTICS_PORTFOLIO_SUCCESS';
export const DATA_ANALYTICS_PORTFOLIO_FAIL = 'DATA_ANALYTICS_PORTFOLIO_FAIL';

// Filter Options
export const DATA_ANALYTICS_FILTER_OPTIONS_START = 'DATA_ANALYTICS_FILTER_OPTIONS_START';
export const DATA_ANALYTICS_FILTER_OPTIONS_SUCCESS = 'DATA_ANALYTICS_FILTER_OPTIONS_SUCCESS';
export const DATA_ANALYTICS_FILTER_OPTIONS_FAIL = 'DATA_ANALYTICS_FILTER_OPTIONS_FAIL';

// High Risk Contract Details
export const DATA_ANALYTICS_HIGH_RISK_DETAILS_START = 'DATA_ANALYTICS_HIGH_RISK_DETAILS_START';
export const DATA_ANALYTICS_HIGH_RISK_DETAILS_SUCCESS = 'DATA_ANALYTICS_HIGH_RISK_DETAILS_SUCCESS';
export const DATA_ANALYTICS_HIGH_RISK_DETAILS_FAIL = 'DATA_ANALYTICS_HIGH_RISK_DETAILS_FAIL';
export const DATA_ANALYTICS_HIGH_RISK_DETAILS_CLEAR = 'DATA_ANALYTICS_HIGH_RISK_DETAILS_CLEAR';
